// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__3WP0d","bigColWidth":"Table_bigColWidth__158Yt","biggerColWidth":"Table_biggerColWidth__2Iuj-","row":"Table_row__1NP55","col":"Table_col__2sf8A"};